import MstLocationComponent from '../Components/Master/Location.tsx';
import { getPageFunction, pageEnum } from '../../security/LoginDetail.js';

export default function MstLocation(){
    const pageFunction = getPageFunction({pageId : pageEnum.MstLocation});
    return (        
        <MstLocationComponent pageFunction={pageFunction} />
    );
}